module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$acl('index-plan')) ? _c('div', {
    staticClass: "component-backoffice-plan-list"
  }, _vm._l((_vm.items), function(plans, status) {
    return _c('div', {
      staticClass: "plan-list"
    }, [_c('div', {
      staticClass: "row column"
    }, [_c('h2', [_vm._v(_vm._s(status))])]), _c('div', {
      staticClass: "row"
    }, _vm._l((plans), function(item) {
      return _c('div', {
        staticClass: "columns plan large-4"
      }, [_c('div', {
        staticClass: "card",
        style: ({
          backgroundImage: _vm.getUrl(item.picture),
          width: '100%',
          height: '200px',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center center'
        })
      }, [_c('div', {
        staticClass: "inner-content",
        class: {
          'img-overlay': item.picture !== null
        }
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'plan',
            params: {
              id: item.id
            }
          }
        }
      }, [_c('h2', [_vm._v("#P" + _vm._s(item.id) + " - " + _vm._s(item.name))])]), _c('h4', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.$priceWithVat(item.cost).toFixed(2))) + " / " + _vm._s(item.billing_cycle) + " days")]), (item.featured) ? _c('h4', [_vm._v("Featured")]) : _vm._e(), (item.default) ? _c('h4', [_vm._v("Default")]) : _vm._e()], 1)])])
    }), 0)])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7fefb2f4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/PlanList.vue
// module id = 2625
// module chunks = 1